import React, { useState, useEffect } from "react";
import Spinner from "../../Spinner";
import { SkeletonProfileForm } from "./SkeletonProfileForm";
import useCompleteProfile from "../Controller/useCompleteProfile.controller";
import useProfile from "../Controller/useProfile.controller";
import { useNavigate } from "react-router-dom";
import "./CompleteProfile.css";
export default function CompleteProfile() {
  const navigate = useNavigate();
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [customGender, setCustomGender] = useState("");
  const [interests, setInterests] = useState("");
  const [bio, setBio] = useState("");
  const [country, setCountry] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [user, setUser] = useState(null);
  const { checkAuth, handleSubmit } = useCompleteProfile({
    navigate,
    setError,
    setLoading,
  });
  const { fetchUser } = useProfile({ setUser, setSuccess: () => {}, setError });
  useEffect(() => {
    checkAuth();
    const userId = sessionStorage.getItem("userId") || localStorage.getItem("userId");
    if (userId) fetchUser(userId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Run only once on mount
  useEffect(() => {
    if (user) {
      const hasDob = !!user.dob?.trim();
      const hasGender = !!user.gender?.trim();
      const hasInterests = !!user.interests?.trim();
      const hasBio = !!user.bio?.trim();
      const hasCountry = !!user.country?.trim();
      const hasProfilePic = !!user.profile_pic?.trim();
      if (hasDob && hasGender && hasInterests && hasBio && hasCountry && hasProfilePic) {
        navigate("/dashboard");
      } else {
        setDob(user.dob || "");
        setGender(user.gender || "");
        setInterests(user.interests || "");
        setBio(user.bio || "");
        setCountry(user.country || "");
        setProfilePic(user.profile_pic || "");
        if (user.gender === "Other") setCustomGender(user.customGender || "");
      }
    }
  }, [user, navigate]);
  const handleProfilePicChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setProfilePic(reader.result);
      reader.readAsDataURL(file);
    }
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    
    try {
      await handleSubmit(
        e,
        undefined,
        dob,
        gender,
        customGender,
        interests,
        bio,
        country,
        profilePic
      );
      
      // Only refetch if submission was successful (navigates to dashboard on success)
    } catch (err) {
      // Error is already handled by handleSubmit
    } finally {
      setLoading(false);
    }
  };
  if (!user) {
    return <SkeletonProfileForm />;
  }
  return (
    <div className="complete-profile-page">
      <div className="complete-profile-card">
        <h2 className="complete-profile-title">Complete Your Profile</h2>
        <form onSubmit={onSubmit} className="complete-profile-form">
          {/* Avatar Upload */}
          <div className="profile-pic-upload">
            <label htmlFor="complete-profile-pic-input" className="profile-pic-upload-btn">
              {profilePic ? "Change Profile Picture" : "Upload Profile Picture"}
            </label>
            <input
              id="complete-profile-pic-input"
              type="file"
              accept="image/*"
              onChange={handleProfilePicChange}
              className="profile-pic-input"
            />
            <p className="profile-pic-upload-hint">Add a profile photo to complete your account setup.</p>
            {profilePic && (
              <img
                src={profilePic}
                className="profile-pic-preview"
                alt="Profile Preview"
              />
            )}
          </div>
          {/* DOB */}
          <label>Date of Birth</label>
          <input
            type="date"
            value={dob}
            onChange={(e) => setDob(e.target.value)}
            className="profile-input"
          />
          {/* Gender */}
          <label>Gender</label>
          <select
            value={gender}
            onChange={(e) => setGender(e.target.value)}
            className="profile-input"
          >
            <option value="">Select</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
          {gender === "Other" && (
            <input
              type="text"
              placeholder="Please specify"
              value={customGender}
              onChange={(e) => setCustomGender(e.target.value)}
              className="profile-input"
            />
          )}
          {/* Interests */}
          <label>Interests / Hobbies</label>
          <input
            type="text"
            placeholder="Comma separated"
            value={interests}
            onChange={(e) => setInterests(e.target.value)}
            className="profile-input"
          />
          {/* Bio */}
          <label>Bio</label>
          <textarea
            placeholder="Tell us about yourself"
            value={bio}
            onChange={(e) => setBio(e.target.value)}
            className="profile-textarea"
            rows={3}
          />
          {/* Country */}
          <label>Country</label>
          <input
            type="text"
            placeholder="Country"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            className="profile-input"
          />
          {/* Buttons */}
          <button type="submit" className="profile-btn" disabled={loading}>
            {loading ? "Saving..." : "Save Profile"}
          </button>
          <button
            type="button"
            className="profile-btn profile-btn-secondary"
            onClick={() => navigate("/dashboard")}
          >
            Fill Form Later
          </button>
          {error && <div className="profile-error">{error}</div>}
        </form>
      </div>
    </div>
  );
}
